import { default as WJElement } from '../wje-element/element.js';
import Container from './container.element.js';

// export * from "./container.element.js";
export default Container;

WJElement.define('wje-container', Container);
